import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';

import type { ChatModeInternal } from './ChatModeInternal';

const getWebSearchDefaultFromStorage = (): boolean | null => {
	if (typeof globalThis === 'undefined' || !globalThis.document || !globalThis.localStorage) {
		return null;
	}
	const value = globalThis.localStorage.getItem('rovo-chat-web-search-default-on');
	if (value === null) {
		return null;
	}
	return value !== 'false';
};

export const getDerivedDefaultChatMode = (): ChatModeInternal => {
	const storageValue = getWebSearchDefaultFromStorage();

	// If localStorage explicitly says it's off, default should be off
	// Otherwise, use the experiment flag value
	const webSearchEnabled =
		storageValue === false
			? false
			: FeatureGates.getExperimentValue('rovo_web_search_default_on', 'isEnabled', false);

	return {
		...{
			reasoningMode: 'auto',
			webSearchEnabled,
			orgKnowledge: {
				filteredApps: [],
			},
			autoApplyEnabled: true,
			appFiltersSetByPrompt: false,
		},
		useCurrentPageContext: fg('disable_default_on_current_page_as_context') ? false : true,
	};
};
